import styled from 'styled-components';
import { stacked } from 'app/shared/styles/_spacing';
// Components
import ToggleButtonBase from 'app/shared/modules/MobileSRP/__BaseComponents__/ToggleButton';

export const FlexList = styled.ul`
  display: flex;
  justify-content: space-between;
  ${stacked._1x};
`;

export const FlexListItem = styled.li`
  flex: 1 1 20%;
  margin: 0 4px 0 0;
`;

export const ToggleButton = styled(ToggleButtonBase)`
  width: 100%;
`;
